import ClimateControlledHero from "assets/images/psp/more-ways-to-store/climate-control.webp";
import TwentyFourHourHero from "assets/images/psp/more-ways-to-store/24hour.webp";
import CollegeHero from "assets/images/psp/more-ways-to-store/college.webp";
import DriveUpHero from "assets/images/psp/more-ways-to-store/drive-up.webp";
import CarHero from "assets/images/psp/more-ways-to-store/car.webp";
import BusinessHero from "assets/images/psp/more-ways-to-store/business.webp";
import RVHero from "assets/images/psp/more-ways-to-store/rv.webp";
import WineHero from "assets/images/psp/more-ways-to-store/wine.webp";
import MotorcycleHero from "assets/images/psp/more-ways-to-store/motorcycle.webp";
import VehicleHero from "assets/images/psp/more-ways-to-store/vehicle.webp";
import DirtBikeHero from "assets/images/psp/more-ways-to-store/dirt-bike.webp";
import GolfCartHero from "assets/images/psp/more-ways-to-store/golf-cart.webp";
import ElectricityHero from "assets/images/psp/more-ways-to-store/electricity.webp";
import PortableStorageHero from "assets/images/psp/more-ways-to-store/portable.webp";
import BoatHero from "assets/images/psp/more-ways-to-store/boat.webp";
import TruckHero from "assets/images/psp/more-ways-to-store/truck.webp";
import MilitaryHero from "assets/images/psp/more-ways-to-store/military.webp";
import ATVHero from "assets/images/psp/more-ways-to-store/ATV.webp";
import BicycleHero from "assets/images/psp/more-ways-to-store/bicycle.webp";
import KayakHero from "assets/images/psp/more-ways-to-store/kayak.webp";
import JetskiHero from "assets/images/psp/more-ways-to-store/jetski.webp";
import SelfStorageHero from "assets/images/psp/more-ways-to-store/self-storage.webp";

/**
 * Content map for all storage types
 * Maps storage type IDs to their display data (title, description, image, link)
 */
export const PSP_LINKS_CONTENT_MAP = {
	vehicle: {
		id: "vehicle",
		image: VehicleHero,
		title: "Vehicle Storage Units",
		description:
			"Storage solutions for cars, trucks, and various vehicles.",
		link: "/storage-solutions/vehicle-storage-units/"
	},
	climate: {
		image: ClimateControlledHero,
		title: "Climate Controlled Storage Units",
		description:
			"Temperature controlled units protect sensitive belongings year-round.",
		link: "/storage-solutions/climate-controlled-storage-units/",
		id: "climate"
	},
	"24Hour": {
		id: "24Hour",
		image: TwentyFourHourHero,
		title: "24 Hour Storage Units",
		description: "Round-the-clock access to your storage unit anytime.",
		link: "/storage-solutions/24-hour-storage-units/"
	},
	driveUp: {
		id: "driveUp",
		image: DriveUpHero,
		title: "Drive Up Storage Units",
		description: "Convenient ground-level units with direct access.",
		link: "/storage-solutions/drive-up-storage-units/"
	},
	electricity: {
		id: "electricity",
		image: ElectricityHero,
		title: "Storage Units With Electricity",
		description:
			"Units with electrical outlets for powered equipment storage.",
		link: "/storage-solutions/storage-units-with-electricity/"
	},
	wine: {
		id: "wine",
		image: WineHero,
		title: "Wine Storage Units",
		description: "Climate controlled storage preserving wine collections.",
		link: "/storage-solutions/wine-storage-units/"
	},
	business: {
		id: "business",
		image: BusinessHero,
		title: "Business Storage Units",
		description: "Storage for business inventory, equipment, and supplies.",
		link: "/storage-solutions/business-storage-units/"
	},
	rv: {
		id: "rv",
		image: RVHero,
		title: "RV Storage Units",
		description: "Secure storage solutions for RVs and motorhomes.",
		link: "/storage-solutions/rv-storage-units/"
	},
	boat: {
		id: "boat",
		image: BoatHero,
		title: "Boat Storage Units",
		description: "Secure storage facilities for boats and marine vehicles.",
		link: "/storage-solutions/boat-storage-units/"
	},
	portable: {
		id: "portable",
		image: PortableStorageHero,
		title: "Portable Storage Units",
		description:
			"Mobile storage units delivered directly to your location.",
		link: "/storage-solutions/portable-storage-units/"
	},
	college: {
		title: "College Student Storage Units",
		id: "college",
		link: "/storage-solutions/college-storage-units/",
		image: CollegeHero,
		description:
			"Student storage solutions for breaks and semester transitions."
	},
	military: {
		title: "Military Storage Units",
		id: "military",
		link: "/storage-solutions/military-storage-units/",
		image: MilitaryHero,
		description:
			"Flexible storage for active duty and deployed military families."
	},
	car: {
		id: "car",
		image: CarHero,
		title: "Car Storage Units",
		description: "Safe, convenient storage options for your automobile.",
		link: "/storage-solutions/car-storage-units/"
	},
	motorcycle: {
		id: "motorcycle",
		image: MotorcycleHero,
		title: "Motorcycle Storage Units",
		description: "Secure indoor storage for motorcycles and riding gear.",
		link: "/storage-solutions/motorcycle-storage-units/"
	},
	dirtBike: {
		id: "dirt-bike",
		image: DirtBikeHero,
		title: "Dirt Bike Storage Units",
		description:
			"Protected storage for off-road motorcycles and dirt bikes.",
		link: "/storage-solutions/dirt-bike-storage-units/"
	},
	truck: {
		id: "free-truck",
		image: TruckHero,
		title: "Storage Units with Free Truck Rentals",
		description: "Rent storage and get a free moving truck included.",
		link: "/storage-solutions/storage-units-with-free-truck-rental/"
	},
	bicycle: {
		id: "bicycle",
		image: BicycleHero,
		title: "Bicycle Storage Units",
		description: "Protected storage for bikes and cycling gear.",
		link: "/storage-solutions/bike-storage-units/"
	},
	atv: {
		title: "ATV Storage Units",
		id: "atv",
		link: "/storage-solutions/atv-storage-units/",
		image: ATVHero,
		description: "Secure storage for ATVs and UTVs."
	},
	kayak: {
		title: "Kayak Storage Units",
		id: "kayak",
		link: "/storage-solutions/kayak-storage-units/",
		image: KayakHero,
		description: "Safe storage for kayaks, canoes, and paddle equipment."
	},
	jetSki: {
		title: "Jet Ski Storage Units",
		id: "jetSki",
		link: "/storage-solutions/jet-ski-storage-units/",
		image: JetskiHero,
		description: "Secure storage for personal watercraft and jet skis."
	},
	golfCart: {
		id: "golfCart",
		image: GolfCartHero,
		title: "Golf Cart Storage Units",
		description: "Covered storage options for golf carts and accessories.",
		link: "/storage-solutions/golf-cart-storage-units/"
	},
	selfStorage: {
		id: "selfStorage",
		image: SelfStorageHero,
		title: "General Storage Units",
		description:
			"Flexible storage spaces for personal and household items.",
		link: "/storage-solutions/what-are-storage-units/"
	}
};
